import type { NextRouter } from "next/router";

function queryIndicatesPropTrading(query: NextRouter["query"] | undefined): boolean {
  const raw = query?.propTrading;
  if (raw === undefined) return false;
  const v = Array.isArray(raw) ? raw[0] : raw;
  return v === "true" || v === "1";
}

/**
 * Prop Trading CFD 场景：需在 CFD 相关接口上带 propTrading=true。
 *
 * - 当前在 `/proptrading/trade/[symbol]`（如 /proptrading/trade/btc_usdx_cfd）
 * - 或从上述页进入 `/futures/record/...?propTrading=true`（历史页仍用该标记；旧链 `/cfd/record/...` 由路由重定向）
 */
export function isPropTradingCfdTradeRoute(
  router: Pick<NextRouter, "pathname" | "asPath" | "query">,
): boolean {
  if (queryIndicatesPropTrading(router.query)) {
    return true;
  }
  if (router.pathname === "/proptrading/trade/[symbol]") {
    return true;
  }
  const path = (router.asPath || "").split("?")[0];
  return path.startsWith("/proptrading/trade/") && path.length > "/proptrading/trade/".length;
}
